var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPerson = function SvgIconPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M8 8a2.666 2.666 0 1 0 0-5.333A2.666 2.666 0 1 0 8 8m0 1.333c-1.78 0-5.333.894-5.333 2.667v1.333h10.666V12c0-1.773-3.553-2.667-5.333-2.667"
  })));
};
export default SvgIconPerson;